import { render, staticRenderFns } from "./DockCard.vue?vue&type=template&id=230ecbbc&scoped=true&"
import script from "./DockCard.vue?vue&type=script&lang=js&"
export * from "./DockCard.vue?vue&type=script&lang=js&"
import style0 from "./DockCard.vue?vue&type=style&index=0&id=230ecbbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ecbbc",
  null
  
)

export default component.exports